var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticStyle:{"fill":"rgb(255, 255, 255)","transform":"","msfilter":""},attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M10.707 17.707 16.414 12l-5.707-5.707-1.414 1.414L13.586 12l-4.293 4.293z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }